import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { PermissionsHttpService } from 'src/app/shared/permissions-http-service/permissions-http.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotifAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private permissions: PermissionsHttpService
  ) { }

  canActivate():
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    return this.permissions
      .checkPermission({ permissions: { accessNotifications: {} } })
      .pipe(
        map((res) => {
          if (res.accessNotifications) {
            return true;
          } else {
            return this.router.createUrlTree(['/']);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
